import axios from '@/axios'
import { usePlayerStore } from '@/stores/playerStore'
import { useDialogStore } from '@/map/stores/dialogStore' // 补充：一定要引入

import { tryGrantNpcVictoryReward } from '@/map/logic/utils/npcVictoryRewards/npcVictoryRewards'


/**
 * 检查某NPC单挑是否已完成
 * @param {string} npcKey - 如 'charizard'（自定义唯一key，建议用npc的id）
 * @returns {Promise<boolean>}
 */
export async function isNpcDefeated(npcKey) {
  const userId = usePlayerStore().id
  const plotKey = `npc_${npcKey}_win`
  try {
    const { data } = await axios.get(`/plot/check/${userId}/${plotKey}`)
    return !!data.finished
  } catch {
    return false
  }
}

/**
 * 记录NPC单挑胜利
 * @param {string} npcKey - 与上面保持一致
 * @returns {Promise<void>}
 */
export async function markNpcDefeated(npcKey) {
  const userId = usePlayerStore().id
  const plotKey = `npc_${npcKey}_win`
  await axios.post('/plot/update', {
    userId,
    plotKey,
    state: 1
  })
}

/**
 * npc胜利后调用：记录击败 + 可弹结算对话
 * @param {string} npcKey - npc唯一id（如"trainer10"）
 * @param {string|Array} [dialog] - 胜利结算对话，可选
 */
export async function handleNpcVictory(npcKey, dialog) {
  // 1. 记录已击败
  await markNpcDefeated(npcKey)

  // 2. 可选结算对话
  if (dialog) {
    const dialogStore = useDialogStore()
    // 支持字符串或数组
    if (typeof dialog === 'string') {
      await dialogStore.showDialogAsync([
        { name: npcKey, text: dialog }
      ])
    } else if (Array.isArray(dialog)) {
      await dialogStore.showDialogAsync(dialog)
    }
  }
}


const npcVictoryDialogs = {
    maptrainer_wudi: [
      { name: 'maptrainer_wudi', emotion: 'normal', text: 'wudi认可你的实力。' },
    ],
    maptrainer_xiba_1: [
      { name: 'xiba', emotion: 'normal', text: '西八认可你的实力。' },
    ],
    maptrainer_luojiechuanzhang_1: [
      { name: 'luojiechuanzhang', emotion: 'normal', text: '罗杰船长认可你的实力。' },
    ],
    maptrainer1: [
        { name: 'liluo', emotion: 'shy', text: '你想操我对吗，今晚来我家吧~' }
      ],
    trainer10: [
      { name: 'trainer10', text: '你竟然击败了我，看来我还得再练练！' }
    ],
    trainer20: [
      { name: 'trainer20', text: '输得心服口服，下次我会赢回来！' }
    ],
    charizard: [
      { name: 'charizard', text: '吼呜！你比我更强！' }
    ],
    maptrainer_lilia_1: [
      { name: 'lilia', emotion: 'normal',  text: '等你打败馆主大人后，记得再来找我聊聊天哦~' }
    ],
    maptrainer_viridian_1: [
      { name: 'viridian', emotion: 'normal', text: '暂时承认你的存在吧，训练家。' },
      { name: 'viridian', emotion: 'normal', text: '或许……你并不是那么无聊的人。' }
    ],
    maptrainer_shuanghanjing_1: [
      { name: 'shuanghanjing', emotion: 'normal', text: '……你的实力让我感到意外。' },
      { name: 'shuanghanjing', emotion: 'normal', text: '雪原也许可以接纳像你这样的训练家。' }
    ],
    maptrainer_ailiya_1: [
      { name: 'ailiya', emotion: 'normal', text: '你的勇气让我印象深刻。' },
      { name: 'ailiya', emotion: 'normal', text: '冰原欢迎真正的强者。' }
    ],
    maptrainer_elf_1: [
      { name: 'elfe', emotion: 'normal', text: '又见面了，训练家！' },
      { name: 'elfe', emotion: 'mock', text: '这次可别掉以轻心，我可不会手下留情。' }
    ]
    
    
    
  }
/**
 * 自动处理NPC胜利结算（如记录胜利、弹出对话等）
 * @param {Object} context - 战斗上下文
 * @param {Object} playerInfo - Pinia中保存的playerInfo字段
 */


// ...
export async function checkAndHandleNpcVictory(context, playerInfo) {
  try {
    const playerId = playerInfo?.self?.id
    const npcId = playerInfo?.opponent?.id
    const isPlayerWin = context?.winnerId === playerId

    if (isPlayerWin && npcId) {
      const defeated = await isNpcDefeated(npcId)
      if (!defeated) {
        const handled = await tryGrantNpcVictoryReward(npcId, playerId)
        if (handled) {
          await handleNpcVictory(npcId) // 只记录击败
          return
        }

        // ✅ 只有定义了才显示胜利对话
        const dialog = npcVictoryDialogs[npcId]
        if (dialog) {
          await handleNpcVictory(npcId, dialog)
        } else {
          await handleNpcVictory(npcId) // 没对话，只记录击败
        }
      }
    }
  } catch (err) {
    console.error('❌ 自动处理NPC胜利失败:', err)
  }
}


